import React, { useState } from "react";

const snackbarDefaultValue = {
  message: "",
  type: "SUCCESS",
  visibleTime: 3000,
  visible: false,
};

const SnackbarContext = React.createContext<any>(snackbarDefaultValue);

type DisplayHandlerType = {
  message: string;
  type: "SUCCESS" | "ERROR" | "INFO" | "WARNING" | "FAILED";
  onClose?: () => void;
  visibleTime?: number;
  visible?: boolean;
  onHide?: boolean;
};

let timer: any;

interface ISnackbarContextProvider {
  children: React.ReactNode;
}

export const SnackBarContextProvider: React.FC<ISnackbarContextProvider> = ({ children }) => {
  const [data, setData] = useState<any>({ message: "", type: "SUCCESS", visible: false, visibleTime: 4000 });

  const displayHandler = (data: DisplayHandlerType) => {
    setData({ ...data });
    if (!data.onHide) {
      timer = setTimeout(() => {
        closeHandler();
      }, data.visibleTime || 3000);
    }
  };

  const closeHandler = () => {
    clearTimeout(timer);
    if (!data.onHide) {
      setData((oldData: any) => ({ ...oldData, visible: false }));
    }
  };

  return (
    <SnackbarContext.Provider
      value={{
        data,
        toggleSnackbar: displayHandler,
        onClose: closeHandler,
      }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarContext;
